export const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

const parseDate = (s: string | null | undefined): Date | null => {
  if (!s) return null
  const d = new Date(s)
  return Number.isNaN(d.getTime()) ? null : d
}

export const fmtDate = (s: string | null | undefined): string => {
  const d = parseDate(s)
  return d
    ? d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    : '—'
}

export const fmtTime = (s: string | null | undefined): string => {
  const d = parseDate(s)
  return d
    ? d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
    : '—'
}

export const fmtDateTime = (s: string | null | undefined): string => {
  const d = parseDate(s)
  if (!d) return '—'
  return `${fmtDate(s)} · ${fmtTime(s)}`
}
